module.exports = __webpack_public_path__ + "img/digital-art-retangle-2.17f92faa.svg";